import React from "react";
import { Form, Row, Col } from "antd";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";
import StablePrime from "../../components/Tables/StablePrime";

function LineDashReport({ lid }) {
  const [form] = Form.useForm();

  const [typ, setTyp] = React.useState(null);

  const Changed = (value) => {
    
    setTyp(form.getFieldsValue());
  };

  const Table = () => {
    return (
      <div style={{ marginTop: "0px" }}>
        <StablePrime
          url="/linedash/tabs/reports"
          data={{ ...typ, lid: lid, limit: 10 }}
          identity=""
        />
      </div>
    );
  };

  return (
    <div className="AuditSection CreateAudit" style={{ marginTop: "-5px" }}>
      <div className="ThemeForm">
        <Form
          name="ReportForm"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          colon={false}
          size="large"
        >
          <Row justify="center">
            <Col span={12}>
              <UniDropAdv
                form={form}
                colSpan={24}
                multiSelect={false}
                url={"/cropdown"}
                disabled={false}
                source={"cropdown"}
                urlData={{ name: "LD_TabReport" }}
                pname={"typ_name"}
                name={"typ"}
                label={"Types"}
                errorMessage={"Please Select Types !"}
                required={true}
                placeholder={"Select Types"}
                defaultValue={null}
                searchable={true}
                includeAll={false}
                onChange={Changed}
              />
            </Col>
          </Row>
        </Form>
        {!typ ? (
          <></>
        ) : (
          <>
            <Table />
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(LineDashReport);
